import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { UnidadMedida, UnidadMedidaInput } from '../../modelos/Configuracion';

export const unidadMedidaService = {
  getAll: (empresaId: string): Promise<ApiResponse<UnidadMedida[]>> => {
    return httpClient.get('/unidad-medidas', { empresaId });
  },

  getById: (id: string): Promise<ApiResponse<UnidadMedida>> => {
    return httpClient.get(`/unidad-medidas/${id}`);
  },

  create: (data: UnidadMedidaInput): Promise<ApiResponse<UnidadMedida>> => {
    return httpClient.post('/unidad-medidas', data);
  },

  update: (id: string, data: UnidadMedidaInput): Promise<ApiResponse<UnidadMedida>> => {
    return httpClient.put(`/unidad-medidas/${id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/unidad-medidas/${id}`);
  },

  toggleVisible: (id: string): Promise<ApiResponse<boolean>> => {
    return httpClient.patch(`/unidad-medidas/${id}/visible`);
  },

  toggleFavorito: (id: string): Promise<ApiResponse<boolean>> => {
    return httpClient.patch(`/unidad-medidas/${id}/favorito`);
  },

  createMany: (data: UnidadMedidaInput[]): Promise<ApiResponse<UnidadMedida[]>> => {
    return httpClient.post('/unidad-medidas/batch', data);
  },
};
